import { ENGLISH } from "@ulaval/modul-components";
import { PluginObject, VueConstructor } from "vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const creerPluginLangage = (langue: string): PluginObject<any> => {
  return {
    install(v: VueConstructor): void {
      if (langue === ENGLISH) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        v.use(require("@ulaval/modul-components/lib/en").default);
      } else {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        v.use(require("@ulaval/modul-components/lib/fr").default);
      }
    },
  };
};

export default creerPluginLangage;
